import type { ApiResponse, WSCallHistorySyncResultData } from '@shared/types';
import { signedIdentityRequest } from './signedIdentityApi';

export type CallConnectedPayload = {
  callSessionId: string;
  connectedAt: number;
};

export type CallFinalizedPayload = {
  callSessionId: string;
  endedAt: number;
  finalStatus: 'answered' | 'rejected' | 'ended' | 'failed';
  durationSeconds?: number;
  reason?: string;
};

export type CallHistoryListPayload = {
  since?: number;
  limit?: number;
};

export type MarkMissedSeenPayload = {
  callSessionIds?: string[];
  peerIdentityId?: string;
  seenAt: number;
};

const CALLS_SCOPE = 'call lifecycle';

export const callsAPI = {
  connected(
    payload: CallConnectedPayload,
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<null>> {
    return signedIdentityRequest({
      path: '/calls/connected',
      type: 'call:connected',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: CALLS_SCOPE
    });
  },

  finalized(
    payload: CallFinalizedPayload,
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<null>> {
    return signedIdentityRequest({
      path: '/calls/finalized',
      type: 'call:finalized',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: CALLS_SCOPE
    });
  },

  listHistory(
    payload: CallHistoryListPayload,
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<WSCallHistorySyncResultData>> {
    return signedIdentityRequest({
      path: '/calls/history/list',
      type: 'call-history:http:list',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: CALLS_SCOPE
    });
  },

  ackHistory(
    payload: { syncedThrough: number },
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<null>> {
    return signedIdentityRequest({
      path: '/calls/history/ack',
      type: 'call-history:http:ack',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: CALLS_SCOPE
    });
  },

  markMissedSeen(
    payload: MarkMissedSeenPayload,
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<null>> {
    return signedIdentityRequest({
      path: '/calls/history/mark-missed-seen',
      type: 'call-history:http:mark-missed-seen',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: CALLS_SCOPE
    });
  }
};
